// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can external-scripts improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const fr = {};

export default fr;
